
const GA_Event = (event, category,action, label) => {
    window.dataLayer.push({
        'event': event,
        'Category': category,
        'Action': action,
        'Label': label
    });
}
const virtualPageView = (url, title) => {
    window.dataLayer.push({
        'event': 'virtualPageview',
        'virtualPageURL': url,
        'virtualPageTitle': title
    });

}

export {
    GA_Event,
    virtualPageView
}